import {Injectable} from '@angular/core';
import {DatesPeriods} from '../../interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class  FechasService {

    month = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ];

    monthR = [
      'Ene',
      'Feb',
      'Mar',
      'Abr',
      'May',
      'Jun',
      'Jul',
      'Ago',
      'Sep',
      'Oct',
      'Nov',
      'Dic',
  ];

  daysName = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
    'Domingo',
  ];

  constructor() {}

  getListDateYYYYMM(dateMax: number, dateMaxLeng: number): DatesPeriods[] {
    const today = new Date();

    // Esta linea es para que empiece un mes más al mes actual
    today.getMonth() + dateMax === 13 ? today.setMonth(1) : today.setMonth(today.getMonth() + 1);

    const fechas: DatesPeriods[] = [];
    let dayNow = 0;
    for (let i = 1; i <= dateMaxLeng; i++) {
      if (dayNow !== 0) {
        today.setMonth(today.getMonth() - 1);
      }

      const mm = String(today.getMonth() + 1);
      const monthNumber = parseInt(mm, 10);
      const yyyy = today.getFullYear();
      const dd = today.getDate();

      fechas.push({
        dateList: yyyy + '-' + (monthNumber === 10 || monthNumber === 11 || monthNumber === 12 ? mm : 0 + mm),
        dateAPi: yyyy + '-' + (monthNumber === 10 || monthNumber === 11 || monthNumber === 12 ? mm : 0 + mm) + '-' + dd,
        monthNumer: mm,
        monthText: this.month[monthNumber - 1],
        year: yyyy
      });

      dayNow++;
    }
    return fechas;
  }

  // Get date Ejemplo: 10 DE DICIEMBRE DE 2020 SIN HORA
  getDatetoday(): string {
    const today = new Date();
    const mm = String(today.getMonth() + 1);
    const yyyy = today.getFullYear();
    const dd = today.getDate();
    const date = '' + dd + ' de ' + this.month[parseInt(mm, 10) - 1] + ' de ' + yyyy;

    return date;
  }

  // Get date Ejemplo: 10 DE DICIEMBRE DE 2020 CON HORA
  getDatetodayWithHour(): string {
    const today = new Date();
    const mm = String(today.getMonth() + 1);
    const yyyy = today.getFullYear();
    const dd = today.getDate();
    const hour = today.getHours();
    const minutes = today.getMinutes();
    const date = '' + dd + ' de ' + this.month[parseInt(mm, 10) - 1] + ' de ' + yyyy + ' ' + hour + ':' + minutes;
    return date;
  }

  // Get date Ejemplo: 10 DIC 2020 SIN HORAS
  getDateFormatR(data): string {
    const today = new Date(data);
    const mm = String((today.getMonth() + 1));
    const yyyy = today.getFullYear();
    const dd = today.getDate();
    const date = '' + dd + ' ' + this.monthR[parseInt(mm, 10) - 1] + ' ' + yyyy;
    return date;
  }

   // Get date Ejemplo: 10 DIC 2020 SIN HORAS
   getDateFormatRWith(data): string {
    const today = new Date(data);
    const mm = String((today.getMonth() + 1));
    const yyyy = today.getFullYear();
    const dd = today.getDate();
    const date = '' + dd + '.' + this.monthR[parseInt(mm, 10) - 1] + '.' + yyyy;
    return date;
  }

  // Get date Ejemplo: 10 DIC 2020 CON HORAS
  getDateFormatRWithHour(data): string {
    const newDate = new Date(data);
    const mm = String((newDate.getMonth() + 1));
    const yyyy = newDate.getFullYear();
    const dd = newDate.getDate();
    const hour = newDate.getHours();
    const minutes = newDate.getMinutes();
    const date = '' + dd + ' ' + this.monthR[parseInt(mm, 10) - 1] + ' ' + yyyy + ' ' + hour + ':' + minutes;
    return date;
  }

  // Get date Ejemplo: 10 DIC 2020 CON HORAS
  getDateFormatRWithHourAMPM(data): string {
    const newDate = new Date(data);
    const mm = String((newDate.getMonth() + 1));
    const yyyy = newDate.getFullYear();
    const dd = newDate.getDate();
    const hour = newDate.getHours() % 12 || 12;
    const minutes = newDate.getMinutes();
    const date = '' + dd + ' ' + this.monthR[parseInt(mm, 10) - 1] + ' ' + yyyy +
      '   ' + hour + ':' + (minutes >= 10 ? minutes : +'0' + minutes.toString() ) + (newDate.getHours() > 12 ? ' p.m.' : ' a.m.');
    return date;
  }

  // Get date Ejemplo: SOLO HORAS
  getDateFormatRWithHours(data): string {
    const newDate = new Date(data);
    const hour = newDate.getHours() % 12 || 12;
    const minutes = newDate.getMinutes();
    const date = '' + hour + ':' + (minutes >= 10 ? minutes : +'0' + minutes.toString() ) + (newDate.getHours() > 12 ? ' p.m.' : ' a.m.');
    return date;
  }

  getDateFormatRMinutes(data): string {
    let minutes: string;
    const today = new Date(data);
    minutes = '' + today.getHours() + ':' + today.getMinutes();
    return minutes;
  }

  getNameDay(fechaComoCadena): string {
    // const fechaComoCadena = "2023-06-11 23:37:22"; // día Domingo
    const numeroDia = new Date(fechaComoCadena).getDay();
    const nombreDia = this.daysName[numeroDia];
    return nombreDia;
  }

  // devulve date 010221 para numero de contrato
  getDateNumerFechaContractNow(): string {
    const today = new Date();
    const mm = String((today.getMonth() + 1));
    const yyyy = today.getFullYear();
    const dd = today.getDate();
    const date = '' + yyyy.toString().slice(2, 4) + (parseInt(mm, 10) >= 10 ? mm : +
      '0' + mm ) + (dd >= 10 ? dd : +'0' + dd.toString()) + '';
    return date;
  }

  // devulve date 20210724
  getDateFormatDayMontYear(d: any): string {
    const today = new Date(d);
    const mm = String((today.getMonth() + 1));
    const yyyy = today.getFullYear();
    const dd = today.getDate();
    const date = '' + yyyy + (parseInt(mm, 10) >= 10 ? mm : +'0' + mm ) + (dd >= 10 ? dd : +'0' + dd.toString()) + '';
    return date;
  }

  // devulve date 2021-07-24-T00:00:00
  getDateFormatDatePiker(d: any): string {
    const today = new Date(d);
    const mm = String((today.getMonth() + 1));
    const yyyy = today.getFullYear();
    const dd = today.getDate();
    const date = '' + yyyy + '-' + (parseInt(mm, 10) >= 10 ? mm : +'0' + mm ) + '-' + (dd >= 10 ? dd : +'0' + dd.toString()) + 'T00:00:00';
    return date;
  }

  // devulve date 2021-07-24-T23:59:59
  getDateFormatDatePiker23(d: any): string {
    const today = new Date(d);
    const mm = String((today.getMonth() + 1));
    const yyyy = today.getFullYear();
    const dd = today.getDate();
    const date = '' + yyyy + '-' + (parseInt(mm, 10) >= 10 ? mm : +'0' + mm ) + '-' + (dd >= 10 ? dd : +'0' + dd.toString()) + 'T23:59:59';
    return date;
  }

  // Get date Ejemplo: NOW devulve date 2021-07-24-T12:52:15 AHORA
  getDateFormatDatePikerDATEHORANOW(): string {
    const newDate = new Date();
    const mm = String((newDate.getMonth() + 1));
    const yyyy = newDate.getFullYear();
    const dd = newDate.getDate();
    const hour = newDate.getHours();
    const minutes = newDate.getMinutes();
    const seconds = newDate.getSeconds();
    const date = '' + yyyy + '-' + (parseInt(mm, 10) >= 10 ? mm : +'0' + mm ) + '-' + (dd >= 10 ? dd : +'0' + dd.toString()) + 'T' +
    (hour >= 10 ? hour : +'0' + hour.toString()) + ':' +
    (minutes >= 10 ? minutes : +'0' + minutes.toString()) + ':' +
    (seconds >= 10 ? seconds : +'0' + seconds.toString()) + '';
    return date;
  }

  // Get date Ejemplo: NOW devulve date 2021-07-24-T12:52:15 AHORA
  getDateFormatDatePikerDATEHORANOWNotSecunt(): string {
    const newDate = new Date();
    const mm = String((newDate.getMonth() + 1));
    const yyyy = newDate.getFullYear();
    const dd = newDate.getDate();
    const hour = newDate.getHours();
    const minutes = newDate.getMinutes();
    const seconds = newDate.getSeconds();
    const date = '' + yyyy + '-' + (parseInt(mm, 10) >= 10 ? mm : +'0' + mm ) + '-' + (dd >= 10 ? dd : +'0' + dd.toString()) + 'T' +
    (hour >= 10 ? hour : +'0' + hour.toString()) + ':' +
    (minutes >= 10 ? minutes : +'0' + minutes.toString());
    return date;
  }

  // Get date Ejemplo: devulve date 07-12-2012 12:52:15
  getDateFormatDateNormal(ddate): string {
    const newDate = new Date(ddate);
    const mm = String((newDate.getMonth() + 1));
    const yyyy = newDate.getFullYear();
    const dd = newDate.getDate();
    const hour = newDate.getHours();
    const minutes = newDate.getMinutes();
    const seconds = newDate.getSeconds();
    const date = '' + (dd >= 10 ? dd : +'0' + dd.toString()) + '/' + (parseInt(mm, 10) >= 10 ? mm : +'0' + mm ) + '/' + yyyy + ' ' +
    (hour >= 10 ? hour : +'0' + hour.toString()) + ':' +
    (minutes >= 10 ? minutes : +'0' + minutes.toString());
    return date;
  }

  // devulve date 2021-07-24
  getDateFormatDateSinHora(d: any): string {
    const today = new Date(d);
    const mm = String((today.getMonth() + 1));
    const yyyy = today.getFullYear();
    const dd = today.getDate();
    const date = '' + yyyy + '-' + (parseInt(mm, 10) >= 10 ? mm : +'0' + mm ) + '-' + (dd >= 10 ? dd : +'0' + dd.toString());
    return date;
  }

  // Date NOow
  getDateNow(): string {
    const today = new Date();

    const mm = String((today.getMonth() + 1));
    const yyyy = today.getFullYear();
    const dd = today.getDate();
    const date = '' + yyyy + '-' + (parseInt(mm, 10) >= 10 ? mm : +'0' + mm ) + '-' + (dd >= 10 ? dd : +'0' + dd.toString()) + 'T00:00:00';
    return date;
  }

  getDateTimeNow(endOfDay: boolean = false): string {
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    const dd = String(today.getDate()).padStart(2, '0');

    const hh = endOfDay ? '23' : String(today.getHours()).padStart(2, '0');
    const min = endOfDay ? '59' : String(today.getMinutes()).padStart(2, '0');
    const ss = '00';

    return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
  }

  // Date fecha con horas
  getDateHours(date): string {
    if (date) {
      const length = date.length;
      if (length >= 19) {
        return date.substring(0, 16);
      } else {
        return date;
      }
    }
  }

  // Calcula si la planilla esta vencida a dos meses
  calculatePlanillaCreate(PeriodEPS: string): boolean {
    let flag = false;
    const nowDate = new Date();
    const D1 = PeriodEPS.slice(-2);
    const D2 = nowDate.getMonth() + 1;
    let D3 = D2 - 1;

    if (D3 === 0) {
      D3 = 12;
    }

    if (
      parseInt(D1, 10) === D2 ||
      parseInt(D1, 10) === D3
    ) {
      flag = true;
    }
    return flag;
  }

  // CALCULA SI LA FECHA ES MAYOR A LA DE HOY
  calculateDateMoreNow(date: Date): boolean {
    let flag = false;
    const nowDate = new Date();
    const D1 = new Date(date);
    if (D1 >= nowDate) {
      flag = true;
    }
    return flag;
  }

  // CALCULA SI LA FECHA 1 es menos que la 2
  calculateDate1IslessDate2(date1, date2): boolean {
    let flag = false;
    const D1 = new Date(date1);
    const D2 = new Date(date2);
    if (D1 < D2) {
      flag = true;
    }
    return flag;
  }

  // CALCULA SI LA FECHA ES MAYOR A LA DE HOY sin tener en cuenta la hora
  calculateStateDate(date: Date, id?): string {
    let flag = '';
    const nowDate = new Date();
    const nowDateVencer = new Date();
    const D1 = new Date(date);
    // Este se vulve habilitar para que no revice la hora si no hasta el final del día 12/08/2022 CAP
    const porVencer = nowDateVencer.setDate(nowDateVencer.getDate() + 8);
    const D2 = new Date(porVencer);
    if (nowDate > D1) {
      flag = 'DateRed';
    } else if (D1.getTime() >= nowDate.getTime()
          && D1.getTime() <= D2.getTime()) {
      flag = 'DateOrange';
    }
    return flag;
  }

  // CALCULA SI LA FECHA ES MAYOR A LA DE HOY teniendo en cuenta la hora
  calculateStateDateEndOfDay(date: Date, id?): string {
    let flag = '';
    const nowDate = new Date();
    const nowDateVencer = new Date();
    const D1 = new Date(date);
    D1.setHours(23, 59, 59, 999);
    const porVencer = nowDateVencer.setDate(nowDateVencer.getDate() + 8);
    const D2 = new Date(porVencer);
    if (nowDate > D1) {
      flag = 'DateRed';
    } else if (D1.getTime() >= nowDate.getTime()
      && D1.getTime() <= D2.getTime()) {
      flag = 'DateOrange';
    }
    return flag;
  }

  // CALCULA SI LA FECHA ES MAYOR A LA DE HOY teniendo en cuenta la hora
  calculateStateDateWithHORA(date: Date, id?): string {
    let flag = '';
    const nowDate = new Date();
    const nowDateVencer = new Date();
    const D1 = new Date(date);
    // Este se vulve habilitar para que no revice la hora si no hasta el final del día 12/08/2022 CAP
    const porVencer = nowDateVencer.setDate(nowDateVencer.getDate() + 8);
    const D2 = new Date(porVencer);
    if (nowDate > D1) {
      flag = 'DateRed';
    } else if (D1.getTime() >= nowDate.getTime()
          && D1.getTime() <= D2.getTime()) {
      flag = 'DateOrange';
    }
    return flag;
  }

  // CALCULA Si la fecha incial es mayor a hoy debe estar en rojo
  calculateStateDateMore(date: Date, id?): string {
    let flag = '';
    const nowDate = new Date();
    const D1 = new Date(date);
    // Si la fecha incial es mayor a hoy debe estar en rojo
    D1.setHours(0, 0, 0);
    if (nowDate < D1) {
      flag = 'DateRed';
    }
    return flag;
  }

  calculateStateDateFromIcon(date: Date): string {
    let flag = '';
    const nowDate = new Date();
    nowDate.setHours(0, 0, 0);
    const nowDateVencer = new Date();
    const D1 = new Date(date);
    D1.setHours(23, 50, 50);
    const porVencer = nowDateVencer.setDate(nowDateVencer.getDate() + 8);
    const D2 = new Date(porVencer);
    if (nowDate > D1) {
      flag = 'person-red';
    } else if (D1.getTime() >= nowDate.getTime()
          && D1.getTime() <= D2.getTime()) {
      flag = 'person-orange';
    }else{
      flag = 'person-blue';
    }
    return flag;
  }

  calcularEdad(fecha) {
    const hoy = new Date();
    const cumpleanos = new Date(fecha);
    let edad = hoy.getFullYear() - cumpleanos.getFullYear();
    const m = hoy.getMonth() - cumpleanos.getMonth();
    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
    }
    return edad;
  }

  // Devuelve true si la fecha esta dentro  del rango - UN MES
  calculateExistDateRango(stardDate, validityDate): boolean {
    let exit = false;
    const validityDateLeessMonth = new Date(validityDate);
    validityDateLeessMonth.setMonth(validityDateLeessMonth.getMonth() - 1);
    const D1 = new Date(validityDate);
    const D2 = new Date(validityDateLeessMonth);
    const D3 = new Date(stardDate);

    if (D3.getTime() <= D1.getTime()
    && D3.getTime() >= D2.getTime()) {
      exit = true;
    }
    return exit;
  }

  // Devuelve true si la fecha esta dentro  del rango - RegularUpdateDays
  calculateRegulareUpdateDays(DateCompanyInfo, RegularUpdateDays): boolean {
    let exit = false;
    const validityDateMoreDays = new Date(DateCompanyInfo);
    validityDateMoreDays.setDate(validityDateMoreDays.getDate() + RegularUpdateDays);

    const D1 = new Date(DateCompanyInfo);
    const D2 = new Date(validityDateMoreDays);
    const D3 = new Date();

    if (D3.getTime() <= D2.getTime()
    && D3.getTime() >= D1.getTime()) {
      exit = true;
    }
    return exit;
  }

  // Fecha Cumpleaños cambiar formato dd-mm-yyy a Date yyyy-mm-dd
  formatDateYYYYMMDD(date: string): string{
    const info = date.split('/').reverse().join('-');
    const newDate: string =  date.slice(6, 8) + '-' + date.slice(4, 6) + '-' + date.slice(0, 4) + 'T00:00:00';
    return info;
  }

  // Fecha  cambiar formato dd-mm-yyy a Date yyyy-mm-dd and DAtePiker CON HORA T00:00:00
  formatDateYYYYMMDDdatePiker(date: string): string {
    const arrayDate = date.split('/').reverse();
    const year = arrayDate[0];
    const mm = parseInt(arrayDate[1], 10) >= 10 ? arrayDate[1] : '0' + arrayDate[1];
    const dd = parseInt(arrayDate[2], 10) >= 10 ? arrayDate[2] : '0' + arrayDate[2];
    const newDate: string = year + '-' + mm + '-' + dd + 'T00:00:00';

    return newDate;
  }

  // Fecha  cambiar formato dd-mm-yyy a Date yyyy-mm-dd and DAtePiker CON HORA T23:59:59
  formatDateYYYYMMDDdatePiker23(date: string): string {
    const arrayDate = date.split('/').reverse();
    const year = arrayDate[0];
    const mm = parseInt(arrayDate[1], 10) >= 10 ? arrayDate[1] : '0' + arrayDate[1];
    const dd = parseInt(arrayDate[2], 10) >= 10 ? arrayDate[2] : '0' + arrayDate[2];
    const newDate: string = year + '-' + mm + '-' + dd + 'T23:59:59';

    return newDate;
  }

  // Fecha  cambiar formato dd-mm-yyy a Date yyyy-mm-dd and DAtePiker CON HORA T23:59:59
  formatDateYYYYMMDDdatePikerWhitMinutes(date: string): string {
    const deleteSpace = date?.replace(' ', '/');
    const arrayDate = deleteSpace?.split('/').reverse();
    const year = arrayDate[1];
    const mm = parseInt(arrayDate[2], 10) >= 10 ? arrayDate[2] : '' + arrayDate[2];
    const dd = parseInt(arrayDate[3], 10) >= 10 ? arrayDate[3] : (arrayDate[3]?.length === 2 ? arrayDate[3] : '0' + arrayDate[3]);
    const newDate: string = dd + ' ' + this.monthR[parseInt(mm, 10) - 1] + ' ' + year + ' ' + arrayDate[0].substring(0, 5);

    return newDate;
  }

  formatDateYYYYMMDD24Hours(dateString: string): string {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return '';
    }

    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    const day = date.getDate().toString().padStart(2, '0');
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day} ${month} ${year} ${hours}:${minutes}`;
  }

  // Fecha  cambiar formato dd-mm-yyy a Date yyyy-mm-dd and DAtePiker SIN HORA
  formatDateYYYYMMDDdatePikerSinhora(date: string): string {
    const arrayDate = date.split('/').reverse();
    const year = arrayDate[0];
    const mm = parseInt(arrayDate[1], 10) >= 10 ? arrayDate[1] : '0' + arrayDate[1];
    const dd = parseInt(arrayDate[2], 10) >= 10 ? arrayDate[2] : '0' + arrayDate[2];
    const newDate: string = year + '-' + mm + '-' + dd;

    return newDate;
  }

  // Fecha Cumpleaños cambiar formato String a Date dd-mm-yyy
  formatBirthDate(date: string): string{
    const newDate: string = date.slice(0, 4) + '-' + date.slice(4, 6) + '-' + date.slice(6, 8) + 'T00:00:00';
    return newDate;
  }

  // Contrato "Liquidado" (INDIVIDUAL CONTRACT), CALCULA SI LA FECHA ES MAYOR A8 DIAS
  calculateDateMoreDays(date: string): boolean{
    let flag = false;
    const nowDate = new Date();
    const validityDateMoreDays = new Date(date);
    validityDateMoreDays.setDate(validityDateMoreDays.getDay() + 8);
    if (nowDate.getTime() < validityDateMoreDays.getTime()) {
      flag = true;
    }
    return flag;
  }

  getShortTime(timeData): string {
    let time = '';
    if (timeData !== null && timeData !== undefined && timeData !== '') {
      const arrayTime = timeData.split(':');
      const AmOrPm =  arrayTime[0] >= 12 ? 'PM' : 'AM';
      const hours = (arrayTime[0] % 12) || 12;
      const min = arrayTime[1];
      time = hours + ':' + min + ' ' + AmOrPm;
    }
    return time;
  }

  getDocumentStatus(dateString: string): 'vigente' | 'por_vencer' | 'vencido' {

    if (!dateString || dateString === 'Sin Fecha') {
      return 'vencido';
    }

    const today = new Date();
    const docDate = new Date(dateString);

    // Diferencia en días entre hoy y la fecha del documento
    const diffMs = docDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    // Regla 3: Hoy o pasado
    if (diffDays <= 0) {
      return 'vencido';
    }

    // Regla 1: En rango de 8 días
    if (diffDays <= 8) {
      return 'por_vencer';
    }

    // Regla 2: Más de 8 días
    return 'vigente';

  }

  startOfDay(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  isUpdateDateOverMaxCalendarDays(updateDateIso: string, maxRequestDays: number, now: Date = new Date()): boolean {
    if (!updateDateIso || !Number.isFinite(maxRequestDays)) { return false; }

    const updateDate = new Date(updateDateIso);
    if (isNaN(updateDate.getTime())) { return false; }

    const a = this.startOfDay(updateDate).getTime();
    const b = this.startOfDay(now).getTime();

    const diffDays = Math.floor((b - a) / (24 * 60 * 60 * 1000));
    return diffDays > maxRequestDays;
  }


}
